import AbstractException from '../AbstractException.js';
import ExceptionTypeEnum from '../enums/ExceptionTypeEnum.js';
/**
 * Custom exception.
 */
export default class ConnectionProblemException extends AbstractException {
    /**
     * Class constructor.
     *
     * @param requestInfo Request info.
     * @param message Message.
     */
    constructor(requestInfo, message) {
        super(`Connection to "${requestInfo.toString()}" failed.${message ? ` Error: ${message}` : ''}`);
        this.exceptionType = ExceptionTypeEnum.connectionProblem;
        this.name = 'ConnectionProblemException';
        this.requestInfo = requestInfo;
    }
}
//# sourceMappingURL=ConnectionProblemException.js.map